import { IoCloseCircle } from "react-icons/io5";
import Style from "./index.module.css";

const DateFilterModal = ({
    show,
    dataInicio,
    setDataInicio,
    dataFim,
    setDataFim,
    onClose,
    onSend,
}) => {
    if (!show) return null;

    return (
        <div className={Style.modalOverlay}>
            <div className={Style.modalContent}>
                <div className={Style.modalHeader}>
                    <h3>Filtrar por Data</h3>
                    <button className={Style.modalCloseButton} onClick={onClose}>
                        <IoCloseCircle />
                    </button>
                </div>

                <div className={Style.modalBody}>
                    <div className={Style.formGroup}>
                        <label>
                            Data Início
                            <input
                                type="date"
                                className={Style.formInput}
                                value={dataInicio || ""}
                                onChange={(e) => setDataInicio(e.target.value)}
                            />
                        </label>

                    </div>

                    <div className={Style.formGroup}>
                        <label>
                            Data Fim
                            <input
                                type="date"
                                className={Style.formInput}
                                value={dataFim || ""}
                                onChange={(e) => setDataFim(e.target.value)}
                            />
                        </label>
                    </div>
                </div>

                <div className={Style.modalFooter}>
                    <button
                        className={Style.cancelButton}
                        onClick={onClose}
                    >
                        Cancelar
                    </button>
                    <button
                        className={Style.confirmButton}
                        onClick={onSend}
                        disabled={!dataInicio && !dataFim}
                    >
                        Filtrar
                    </button>
                </div>
            </div>
        </div>
    );
};

export { DateFilterModal };
